import blog_img_2 from "../assets/images/blogs/blog_img_2.jpg";
import Day_3_Recap_Main_Page from "../assets/images/blogs/Day_3_Recap_Main_Page.jpg";
import blog_img_3 from "../assets/images/blogs/blog_img_3.jpg";
import blog_img_4 from "../assets/images/blogs/blog_img_4.jpg";
import blog_img_5 from "../assets/images/blogs/blog_img_5.jpg";
import blog_img_6 from "../assets/images/blogs/blog_img_6.png";
import blog_img_7 from "../assets/images/blogs/blog_img_7.png";
import blog_img_8 from "../assets/images/blogs/blog_img_8.png";
import blog_img_9 from "../assets/images/blogs/blog_img_9.png";
import blog_img_10 from "../assets/images/blogs/blog_img_10.png";
import blog_img_11 from "../assets/images/blogs/blog_img_11.png";
import blog_img_12 from "../assets/images/blogs/blog_img_12.png";
import blog_img_13 from "../assets/images/blogs/blog_img_13.jpg";
import blog_img_14 from "../assets/images/blogs/blog_img_14.jpg";
import blog_img_15 from "../assets/images/blogs/blog_img_15.jpg";
import blog_img_16 from "../assets/images/blogs/blog_img_16.jpg";
import blog_img_17 from "../assets/images/blogs/blog_img_17.png";
import blog_img_18 from "../assets/images/blogs/blog_img_18.png";
import blog_img_19 from "../assets/images/blogs/blog_img_19.png";

const insightsData = [
  {
    id: 1,
    imageName: blog_img_2,
    date: "09 Dec, 2024",
    title: "Top Announcements of AWS re:Invent 2024",
    content: "AWS re:Invent 2024",
    buttonLabel: "Read More",
    buttonLink: "/blog/top-announcements-of-aws-re-Invent-2024",
    slug: "top-announcements-of-aws-re:Invent-2024",
    filename: "post1.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2024"],
    keywords: [
      "AWS re:Invent 2024",
      "aws reinvent 2024 announcements",
      "aws reinvent 2024 top announcements",
      "aws relnvent announcements",
      "aws reinvent updates",
    ],
  },
  {
    id: 2,
    imageName: Day_3_Recap_Main_Page,
    date: "05 Dec, 2024",
    title: "AWS re:Invent 2024 – Day 3 Recap",
    content: "AWS re:Invent 2024",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2024-day-3-recap",
    slug: "aws-reinvent-2024-day-3-recap",
    filename: "post2.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2024"],
    keywords: [
      "AWS re:Invent 2024",
      "aws reinvent 2024 day 3",
      "aws reinvent 2024 day 3 recap",
      "aws reinvent keynote",
      "matt garman keynotes 2024",
    ],
  },
  {
    id: 3,
    imageName: blog_img_3,
    date: "04 Dec, 2024",
    title: "AWS re:Invent 2024 – Day 2 Recap",
    content: "AWS re:Invent 2024",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2024-day-2-recap",
    slug: "aws-reinvent-2024-day-2-recap",
    filename: "post3.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2024"],
    keywords: [
      "aws reinvent 2024",
      "aws reinvent 2024 day 2",
      "aws reinvent 2024 day 2 recap",
      "aws reinvent keynote",
      "matt garman keynotes 2024",
    ],
  },
  {
    id: 4,
    imageName: blog_img_4,
    date: "03 Dec, 2024",
    title: "AWS re:Invent 2024 – Day 1 Recap",
    content: "AWS re:Invent 2024",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2024-day-1-recap",
    slug: "aws-reinvent-2024-day-1-recap",
    filename: "post4.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2024"],
    keywords: [
      "aws reinvent 2024",
      "aws reinvent 2024 day 1",
      "aws reinvent 2024 day 1 recap",
      "aws reinvent keynote",
      "peter desantis keynotes 2024",
    ],
  },
  {
    id: 5,
    imageName: blog_img_5,
    date: "26 Nov, 2024",
    title: "What to Expect from AWS re:Invent 2024",
    content: "AWS re:Invent 2024",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2024-keynote-highlights",
    slug: "aws-reinvent-2024-keynote-highlights",
    filename: "post5.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2024"],
    keywords: [
      "aws conference 2024",
      "aws reinvent",
      "aws reinvent 2024",
      "aws reinvent 2024 announcements",
      "aws reinvent 2024 news",
      "aws reinvent 2024 updates",
      "what to expect from aws reinvent 2024",
    ],
  },
  {
    id: 6,
    imageName: blog_img_6,
    date: "4 Dec, 2023",
    title: "Top Announcements of AWS re:Invent 2023",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/top-announcements-of-aws-re:Invent-2023",
    slug: "top-announcements-of-aws-re:Invent-2023",
    filename: "post6.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 highlights",
      "aws reinvent 2023 news",
      "aws reinvent 2023 top announcements",
      "aws reinvent 2023 updates",
    ],
  },
  {
    id: 7,
    imageName: blog_img_7,
    date: "1 Dec, 2023",
    title: "AWS re:Invent 2023 – Day 4 Recap",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2023-day-4-recap",
    slug: "aws-reinvent-2023-day-4-recap",
    filename: "post7.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "amazon cloudwatch application signals",
      "amazon inspector",
      "amazon sagemaker studio",
      "aws management console",
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 day 4 recap",
      "aws reinvent 2023 news",
      "aws reinvent 2023 updates",
    ],
  },
  {
    id: 8,
    imageName: blog_img_8,
    date: "30 Nov, 2023",
    title: "AWS re:Invent 2023 – Day 3 Recap",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2023-day-3-recap",
    slug: "aws-reinvent-2023-day-3-recap",
    filename: "post8.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "amazon neptune analytics",
      "amazon redshift",
      "amazon sagemaker canvas",
      "amazon sagemaker hyperPod",
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 day 3 recap",
      "aws reinvent 2023 news",
      "aws reinvent 2023 updates",
      "aws titan image generator",
    ],
  },
  {
    id: 9,
    imageName: blog_img_9,
    date: "29 Nov, 2023",
    title: "AWS re:Invent 2023 – Day 2 Recap",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2023-day-2-recap",
    slug: "aws-reinvent-2023-day-2-recap",
    filename: "post9.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "amazon bedrock",
      "amazon dynamodb zero etl integration",
      "amazon q",
      "amazon transcribe",
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 day 2 recap",
      "aws reinvent 2023 news",
      "aws reinvent 2023 updates",
    ],
  },
  {
    id: 10,
    imageName: blog_img_10,
    date: "28 Nov, 2023",
    title: "AWS re:Invent 2023 – Day 1 Recap",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/aws-reinvent-2023-day-1-recap",
    slug: "aws-reinvent-2023-day-1-recap",
    filename: "post10.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 day 1 recap",
      "aws reinvent 2023 news",
      "aws reinvent 2023 updates",
      "aws reinvent updates",
    ],
  },
  {
    id: 11,
    imageName: blog_img_11,
    date: "20 Nov, 2023",
    title: "What to Expect from AWS re:Invent 2023",
    content: "AWS re:Invent 2023",
    buttonLabel: "Read More",
    buttonLink: "/blog/what-to-expect-from-aws-reinvent-2023",
    slug: "what-to-expect-from-aws-reinvent-2023",
    filename: "post11.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AWS re:Invent 2023"],
    keywords: [
      "aws conference 2023",
      "aws reinvent",
      "aws reinvent 2023",
      "aws reinvent 2023 announcements",
      "aws reinvent 2023 news",
      "aws reinvent 2023 updates",
      "what to expect from aws reinvent 2023",
    ],
  },
  {
    id: 12,
    imageName: blog_img_12,
    date: "10 Sep, 2024",
    title: "Why Cloud Security is Essential for Every Organization?",
    content: "Cloud Security",
    buttonLabel: "Read More",
    buttonLink: "/blog/why-cloud-security-is-essential-for-every-organization",
    slug: "why-cloud-security-is-essential-for-every-organization",
    filename: "post12.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cloud Security"],
    keywords: [
      "aws security services",
      "cloud computing security",
      "cloud cyber security",
      "cloud data security",
      "cloud security",
      "cloud security in cloud computing",
      "cloud security services",
      "cloud security solutions",
      "cloud server security",
      "cloud web security",
    ],
  },
  {
    id: 13,
    imageName: blog_img_13,
    date: "09 Jul, 2024",
    title: "Why Enterprises Should Adopt a Multi-Cloud Strategy",
    content: "Cloud Computing",
    buttonLabel: "Read More",
    buttonLink: "/blog/why-enterprises-should-adopt-a-multi-cloud-strategy",
    slug: "why-enterprises-should-adopt-a-multi-cloud-strategy",
    filename: "post13.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cloud Computing"],
    keywords: [
      "enterprise multi cloud",
      "multi cloud adoption",
      "multi cloud capabilities",
      "multi cloud for enterprises",
      "multi cloud strategy",
    ],
  },
  {
    id: 14,
    imageName: blog_img_14,
    date: "15 May, 2024",
    title: "Data Security Challenges in Cloud Computing",
    content: "Cloud Computing",
    buttonLabel: "Read More",
    buttonLink: "/blog/data-security-challenges-in-cloud-computing",
    slug: "data-security-challenges-in-cloud-computing",
    filename: "post14.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cloud Computing"],
    keywords: [
      "cloud data security",
      "cloud storage security issues",
      "data security in cloud computing",
      "data security techniques in cloud computing",
    ],
  },
  {
    id: 15,
    imageName: blog_img_15,
    date: "21 Mar, 2024",
    title: "Top 5 Cybersecurity Challenges for the Financial Service Industry",
    content: "Cyber Security",
    buttonLabel: "Read More",
    buttonLink:
      "/blog/top-5-cybersecurity-challenges-for-the-financial-service-industry",
    slug: "top-5-cybersecurity-challenges-for-the-financial-service-industry",
    filename: "post15.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cyber Security"],
    keywords: [
      "cyber security banking industry",
      "cyber security in banking sector",
      "cyber security threats to the financial sector",
      "cyber threats to banking industry",
      "financial services cybersecurity",
    ],
  },
  {
    id: 16,
    imageName: blog_img_16,
    date: "19 Jan, 2024",
    title: "Top 10 Advantages of Cloud Computing",
    content: "Cloud Computing",
    buttonLabel: "Read More",
    buttonLink: "/blog/top-10-advantages-of-cloud-computing",
    slug: "top-10-advantages-of-cloud-computing",
    filename: "post16.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cloud Computing"],
    keywords: [
      "advantages of cloud",
      "advantages of cloud computing",
      "advantages of cloud computing for business",
      "advantages of cloud storage",
      "advantages of using cloud computing",
      "aws cloud",
      "benefits of cloud",
      "benefits of cloud computing",
      "cloud computing",
    ],
  },
  // New blogs
  {
    id: 17,
    imageName: blog_img_17,
    date: "21 Jan, 2025",
    title:
      "The Role of Automation in Cloud Migration: How AI and ML Enhance Efficiency",
    content: "Cloud Innovations",
    buttonLabel: "Read More",
    buttonLink: "/blog/the-role-of-automation-in-cloud-migration",
    slug: "the-role-of-automation-in-cloud-migration",
    filename: "post17.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Cloud Innovations"],
    keywords: [
      "cloud consulting services",
      "cloud advisory services",
      "cloud migration services",
      "application migration service",
      "cloud data migration",
    ],
  },
  {
    id: 18,
    imageName: blog_img_18,
    date: "11 Feb, 2025",
    title:
      "The AI-Driven Bank: How Banking Intelligence is Changing Risk, Compliance, and Customer Strategy",
    content: "AI Banking",
    buttonLabel: "Read More",
    buttonLink:
      "/blog/the-ai-driven-bank-how-banking-intelligence-is-changing-risk-compliance-and-customer-strategy",
    slug: "the-ai-driven-bank-how-banking-intelligence-is-changing-risk-compliance-and-customer-strategy",
    filename: "post18.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["AI Banking"],
    keywords: [
      "banking solutions",
      "banking ai solutions",
      "ai solutions for banks",
      "ai banking",
      "artificial intelligence in banking",
    ],
  },
  {
    id: 19,
    imageName: blog_img_19,
    date: "13 Mar, 2025",
    title:
      "From Generative AI to Autonomous AI: What’s Next for Enterprise AI Solutions?",
    content: "Enterprise AI",
    buttonLabel: "Read More",
    buttonLink:
      "/blog/from-generative-ai-to-autonomous-ai-whats-next-for-enterprise-ai-solutions",
    slug: "from-generative-ai-to-autonomous-ai-whats-next-for-enterprise-ai-solutions",
    filename: "post19.md",
    backgroundImage: "simplifying-compliance-for-asset-based-lending.jpg",
    boxName: "BLOG",
    tags: ["Enterprise AI"],
    keywords: [
      "ai enterprise solutions",
      "ai solutions for enterprise",
      "enterprise ai solutions",
      "enterprise ai",
      "ai for enterprise",
    ],
  },
];

export default insightsData;
